import {RootState} from "../../types";

export const getSyncDevices = (state: RootState) => state.sync.devices;

export const getAccountDevices = (state: RootState) => state.sync.accountDevices;

export const firstRoundSyncsComplete = (state: RootState) => state.sync.firstRoundSyncComplete;

export const getSyncedItemCount = (state: RootState) => state.sync.numItemsSynced;